import { FC, useEffect, useRef, useState } from "react";

interface IInputCol {
  prop: string;
  handleSelection: (arg?: any) => any;
  setInputValue: (arg?: any) => any;
  inputValue: any;
}

const InputCol: FC<IInputCol> = ({
  prop,
  handleSelection,
  setInputValue,
  inputValue,
}) => {
  const [color, setColor] = useState(true);
  const inputValueRef = useRef();

  useEffect(() => {
    if ((inputValue as boolean) && color) setColor(true);
  }, [inputValue]);

  useEffect(() => {
    if (inputValue as boolean) inputValueRef.current = inputValue;
  }, []);
  // console.log("value ref ", inputValueRef.current, "   value : ", inputValue);
  return (
    <input
      type="text"
      name={prop}
      placeholder="Hourly Pay"
      value={inputValue ?? ""}
      onKeyDown={(e: any) => {
        e.key === "Enter" && handleSelection(e);
      }}
      onChange={(e) => {
        setInputValue(e.target.value);
        if (color) setColor(false);
      }}
      className={`bg-white outline-none border-none px-2 py-1 ${
        color ? "text-gray-500" : "text-black"
      }`}
      onBlur={(e) => {
        if (inputValueRef.current !== inputValue) {
          handleSelection(e);
          inputValueRef.current = inputValue;
        }
        // handleSelection(e);
      }}
    />
  );
};

export default InputCol;
